module.exports = __webpack_public_path__ + "img/C3.c51a1866.png";